export var State;
(function (State) {
    State[State["ACTIVE"] = 1] = "ACTIVE";
    State[State["HIDDEN"] = 2] = "HIDDEN";
    State[State["INACTIVE"] = 400] = "INACTIVE";
    State[State["NOT_CONFIRMED"] = 401] = "NOT_CONFIRMED";
})(State || (State = {}));
export var StateString;
(function (StateString) {
    StateString["ACTIVE"] = "ACTIVE";
    StateString["HIDDEN"] = "HIDDEN";
    StateString["INACTIVE"] = "INACTIVE";
    StateString["NOT_CONFIRMED"] = "NOT_CONFIRMED";
})(StateString || (StateString = {}));
export const StateTranslation = {
    [State.ACTIVE]: 'Aktywny',
    [State.HIDDEN]: 'Ukryty',
    [State.INACTIVE]: 'Nieaktywny',
    [State.NOT_CONFIRMED]: 'Niepotwierdzony'
};
//# sourceMappingURL=state.enum.js.map